class CollectionTilesSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.collection-tiles-grid');
    this.slides = this.querySelectorAll('.slider__slide');
    this.currentIndex = 0;
    this.isMobile = window.innerWidth <= 990;

    if (this.isMobile && this.slides.length > 1) {
      this.init();
    }

    window.addEventListener('resize', () => {
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth <= 990;
      
      if (this.isMobile && !wasMobile && this.slides.length > 1) {
        this.init();
      } else if (!this.isMobile && wasMobile) {
        this.destroy();
      }
    });
  }

  init() {
    this.createDots();
    this.slider.scrollLeft = 0;
    this.currentIndex = 0;
    this.updateSlide();
    this.addSwipeListeners();
  }

  destroy() {
    const dotsContainer = this.querySelector('.collection-tiles-dots');
    if (dotsContainer) {
      dotsContainer.remove();
    }
    this.slider.scrollLeft = 0;
  }

  createDots() {
    if (this.querySelector('.collection-tiles-dots')) return;

    const dotsContainer = document.createElement('div');
    dotsContainer.className = 'collection-tiles-dots';

    this.slides.forEach((_, index) => {
      const dot = document.createElement('button');
      dot.className = 'collection-tiles-dot';
      dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
      if (index === 0) dot.classList.add('active');
      
      dot.addEventListener('click', () => {
        this.goToSlide(index);
      });
      
      dotsContainer.appendChild(dot);
    });

    this.appendChild(dotsContainer);
  }

  updateSlide() {
    if (!this.isMobile) return;
    
    const slideWidth = window.innerWidth;
    const scrollPosition = this.currentIndex * slideWidth;

    this.slider.scrollTo({
      left: scrollPosition,
      behavior: 'smooth'
    });

    // Update dots
    const dots = this.querySelectorAll('.collection-tiles-dot');
    dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === this.currentIndex);
    });
  }

  goToSlide(index) {
    this.currentIndex = index;
    this.updateSlide();
  }

  addSwipeListeners() {
    let startX = 0;
    let scrollLeft = 0;

    this.slider.addEventListener('touchstart', (e) => {
      startX = e.touches[0].pageX;
      scrollLeft = this.slider.scrollLeft;
    });

    this.slider.addEventListener('touchend', (e) => {
      const endX = e.changedTouches[0].pageX;
      const diff = startX - endX;

      if (Math.abs(diff) > 50) {
        if (diff > 0 && this.currentIndex < this.slides.length - 1) {
          this.currentIndex++;
        } else if (diff < 0 && this.currentIndex > 0) {
          this.currentIndex--;
        }
        this.updateSlide();
      }
    });

    // Update current slide on scroll end
    let scrollTimeout;
    this.slider.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        const slideWidth = window.innerWidth;
        const newIndex = Math.round(this.slider.scrollLeft / slideWidth);
        
        if (newIndex !== this.currentIndex && newIndex >= 0 && newIndex < this.slides.length) {
          this.currentIndex = newIndex;
          const dots = this.querySelectorAll('.collection-tiles-dot');
          dots.forEach((dot, index) => {
            dot.classList.toggle('active', index === this.currentIndex);
          });
        }
      }, 100);
    });
  }
}

customElements.define('collection-tiles-slider', CollectionTilesSlider);
